// extracted by mini-css-extract-plugin
module.exports = {"whvx89d":"whvx89d"};